const softwareData = [
  {
    "id": 1,
    "name": "Chrome浏览器",
    "category": "浏览器",
    "icon": "🌐",
    "description": "Google Chrome 是一款快速、安全且免费的网络浏览器，内置 Google 智能工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/25308.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/1/detail_1.html" },
      { "name": "官方下载", "url": "https://www.google.cn/chrome/" }
    ]
  },
  {
    "id": 2,
    "name": "VS Code",
    "category": "开发工具",
    "icon": "💻",
    "description": "Visual Studio Code 是一款轻量级但功能强大的源代码编辑器，支持数百种语言。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577123.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/16/detail_22856.html" },
      { "name": "官方下载", "url": "https://code.visualstudio.com/" }
    ]
  },
  {
    "id": 3,
    "name": "微信",
    "category": "社交通讯",
    "icon": "💬",
    "description": "微信 PC 版，极致简洁的沟通体验，支持跨平台消息同步。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577546.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/10/detail_11490.html" },
      { "name": "官方下载", "url": "https://weixin.qq.com/" }
    ]
  },
  {
    "id": 4,
    "name": "Photoshop",
    "category": "图像处理",
    "icon": "🎨",
    "description": "全球顶尖的图像处理与设计软件，支持图片编辑、合成及数字绘图。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/23764.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_1232.html" },
      { "name": "官方下载", "url": "https://www.adobe.com/products/photoshop.html" }
    ]
  },
  {
    "id": 5,
    "name": "网易云音乐",
    "category": "影音娱乐",
    "icon": "🎵",
    "description": "专注于发现与分享的音乐产品，依托专业音乐人、DJ、好友推荐及社交功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/522500.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/15/detail_13035.html" },
      { "name": "官方下载", "url": "https://music.163.com/#/download" }
    ]
  },
  {
    "id": 6,
    "name": "7-Zip",
    "category": "系统工具",
    "icon": "📦",
    "description": "开源、高压缩比的解压缩软件，支持多种主流压缩格式。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/3553.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_2673.html" },
      { "name": "官方下载", "url": "https://www.7-zip.org/" }
    ]
  },
  {
    "id": 7,
    "name": "EditPlus",
    "category": "文本编辑",
    "icon": "📝",
    "description": "一套功能强大的文本编辑器，可取代记事本，并内置 FTP/FTPS 传输功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/7133.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/16/detail_1196.html" },
      { "name": "官方下载", "url": "https://www.editplus.com/" }
    ]
  },
  {
    "id": 8,
    "name": "QQ",
    "category": "社交通讯",
    "icon": "🐧",
    "description": "腾讯官方出品的多功能聊天软件，支持文件传输、语音视频通话等。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/20355.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/10/detail_11130.html" },
      { "name": "官方下载", "url": "https://im.qq.com/" }
    ]
  },
  {
    "id": 9,
    "name": "Office",
    "category": "办公软件",
    "icon": "🏢",
    "description": "Microsoft 365 办公套件，包含 Word, Excel, PowerPoint 等核心工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/578278.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/10/detail_1590.html" },
      { "name": "官方下载", "url": "https://www.office.com/" }
    ]
  },
  {
    "id": 10,
    "name": "WPS",
    "category": "办公软件",
    "icon": "📑",
    "description": "金山办公出品的国产办公套件，支持文字、表格、演示及 PDF 阅读编辑。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/2361.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/7/detail_2807.html" },
      { "name": "官方下载", "url": "https://www.wps.cn/" }
    ]
  },
  {
    "id": 11,
    "name": "企业微信",
    "category": "办公通讯",
    "icon": "👔",
    "description": "腾讯推出的专业办公管理工具，与微信生态打通，助力企业高效协同。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577884.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/11/detail_21531.html" },
      { "name": "官方下载", "url": "https://work.weixin.qq.com/" }
    ]
  },
  {
    "id": 12,
    "name": "Nodejs",
    "category": "运行环境",
    "icon": "🚀",
    "description": "基于 Chrome V8 引擎的 JavaScript 运行环境，用于构建高性能网络应用。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/580045.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/14/detail_23394.html" },
      { "name": "官方下载", "url": "https://nodejs.org/" }
    ]
  },
  {
    "id": 13,
    "name": "Firefox",
    "category": "浏览器",
    "icon": "🦊",
    "description": "Mozilla 开发的自由开源浏览器，注重隐私保护与个性化扩展。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/3629.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/1/detail_101.html" },
      { "name": "官方下载", "url": "https://www.firefox.com.cn/" }
    ]
  },
  {
    "id": 14,
    "name": "Git",
    "category": "版本控制",
    "icon": "🌿",
    "description": "分布式版本控制系统，能够高效处理从小型到大型的项目代码管理。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577121.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_22693.html" },
      { "name": "官方下载", "url": "https://git-scm.com/" }
    ]
  },
  {
    "id": 15,
    "name": "JDK",
    "category": "开发环境",
    "icon": "☕",
    "description": "Java SE 开发工具包，包含运行和开发 Java 程序所需的核心类库与工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/12258.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_56573.html" },
      { "name": "官方下载", "url": "https://www.oracle.com/java/technologies/downloads/" }
    ]
  },
  {
    "id": 16,
    "name": "Postman",
    "category": "开发工具",
    "icon": "📮",
    "description": "一款用于 API 开发和测试的协同平台，支持构建、调试及文档生成。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10014168.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/15/detail_23235.html" },
      { "name": "官方下载", "url": "https://www.postman.com/downloads/" }
    ]
  },
  {
    "id": 17,
    "name": "Python",
    "category": "开发语言",
    "icon": "🐍",
    "description": "一种广泛使用的解释型、高级编程语言，设计哲学强调代码的可读性。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577048.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/14/detail_23194.html" },
      { "name": "官方下载", "url": "https://www.python.org/downloads/" }
    ]
  },
  {
    "id": 18,
    "name": "QQ音乐",
    "category": "影音娱乐",
    "icon": "💚",
    "description": "腾讯出品的音乐流媒体平台，拥有海量正版曲库和无损音质体验。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/45769.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/15/detail_115.html" },
      { "name": "官方下载", "url": "https://y.qq.com/download/index.html" }
    ]
  },
  {
    "id": 19,
    "name": "Obsidian",
    "category": "效率笔记",
    "icon": "💎",
    "description": "强大的本地优先、基于 Markdown 的双链笔记软件，支持海量插件扩展。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10055747.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/2/detail_26942.html" },
      { "name": "官方下载", "url": "https://obsidian.md/download" }
    ]
  },
  {
    "id": 20,
    "name": "印象笔记",
    "category": "效率笔记",
    "icon": "🐘",
    "description": "Evernote 中国版，支持多端同步的知识管理与信息采集工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/26500.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/11/detail_1231.html" },
      { "name": "官方下载", "url": "https://www.yinxiang.com/download/" }
    ]
  },
  {
    "id": 21,
    "name": "TortoiseGit",
    "category": "开发工具",
    "icon": "🐢",
    "description": "Windows 壳层界面下的 Git 客户端，通过右键菜单直接管理代码版本。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/101019.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_22653.html" },
      { "name": "官方下载", "url": "https://tortoisegit.org/download/" }
    ]
  },
  {
    "id": 22,
    "name": "Visual Studio",
    "category": "开发工具",
    "icon": "🟣",
    "description": "微软出品的全功能集成开发环境 (IDE)，适用于 .NET、C++ 及云开发。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/578277.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/14/detail_1594.html" },
      { "name": "官方下载", "url": "https://visualstudio.microsoft.com/zh-hans/downloads/" }
    ]
  },
  {
    "id": 23,
    "name": "IntelliJ IDEA",
    "category": "开发工具",
    "icon": "💡",
    "description": "JetBrains 出品的 Java 集成开发环境，被公认为最智能的 Java 开发工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10006316.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/10/detail_23210.html" },
      { "name": "官方下载", "url": "https://www.jetbrains.com/idea/download/" }
    ]
  },
  {
    "id": 24,
    "name": "Eclipse",
    "category": "开发工具",
    "icon": "🌑",
    "description": "经典开源集成开发环境，广泛用于 Java 开发及各类插件扩展。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/32280.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_1292.html" },
      { "name": "官方下载", "url": "https://www.eclipse.org/downloads/" }
    ]
  },
  {
    "id": 25,
    "name": "foobar2000",
    "category": "影音娱乐",
    "icon": "👽",
    "description": "顶级本地音频播放器，以极低的资源占用和高度可定制化著称。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/2893.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_2032.html" },
      { "name": "官方下载", "url": "https://www.foobar2000.org/download" }
    ]
  },
  {
    "id": 26,
    "name": "WinRAR",
    "category": "系统工具",
    "icon": "📚",
    "description": "流行高效的压缩解压软件，支持 RAR 及 ZIP 格式，提供强大的加密功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/5.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/3/detail_3.html" },
      { "name": "官方下载", "url": "https://www.win-rar.com/download.html" }
    ]
  },
  {
    "id": 27,
    "name": "HoYoPlay (米哈游启动器)",
    "category": "游戏娱乐",
    "icon": "🌌",
    "description": "米哈游旗下 PC 游戏聚合启动器，支持原神、崩坏：星穹铁道等游戏。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10101569.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/0/detail_28440.html" },
      { "name": "官方下载", "url": "https://www.hoyolab.com/hoyoplay" }
    ]
  },
  {
    "id": 28,
    "name": "QQ拼音",
    "category": "系统工具",
    "icon": "⌨️",
    "description": "腾讯开发的输入法，打字速度快，词库精准，皮肤丰富。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/63422.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/10/detail_110.html" },
      { "name": "官方下载", "url": "https://pinyin.qq.com/" }
    ]
  },
  {
    "id": 29,
    "name": "Cursor",
    "category": "开发工具",
    "icon": "🤖",
    "description": "基于 AI 的新一代代码编辑器，深度整合 LLM，极大提升编程效率。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10099499.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/search.html#keyword=Cursor" },
      { "name": "官方下载", "url": "https://www.cursor.com/" }
    ]
  },
  {
    "id": 30,
    "name": "暴雪战网",
    "category": "游戏娱乐",
    "icon": "🌀",
    "description": "暴雪官方游戏平台，支持魔兽世界、炉石传说等游戏的启动与更新。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/471010.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/11/detail_11051.html" },
      { "name": "官方下载", "url": "https://download.battle.net/" }
    ]
  },
  {
    "id": 31,
    "name": "PotPlayer",
    "category": "影音娱乐",
    "icon": "🎥",
    "description": "来自韩国的强力本地视频播放器，解码器丰富，画质还原度极高。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/66838.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_3853.html" },
      { "name": "官方下载", "url": "https://potplayer.daum.net/" }
    ]
  },
  {
    "id": 32,
    "name": "钉钉",
    "category": "办公通讯",
    "icon": "🔨",
    "description": "阿里巴巴出品的协同办公平台，支持考勤、审批及高清视频会议。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577000.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/0/detail_21280.html" },
      { "name": "官方下载", "url": "https://www.dingtalk.com/static/zh-cn/download" }
    ]
  },
  {
    "id": 33,
    "name": "豆包",
    "category": "人工智能",
    "icon": "🌈",
    "description": "字节跳动出品的 AI 智能助手，基于云雀模型，支持聊天、创作及语音交互。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10097722.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/search.html#keyword=%E8%B1%86%E5%8C%85" },
      { "name": "官方下载", "url": "https://www.doubao.com/" }
    ]
  },
  {
    "id": 34,
    "name": "DeepSeek",
    "category": "人工智能",
    "icon": "🧠",
    "description": "深度求索官方客户端/网页入口，提供顶尖推理能力的 AI 语言模型。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10099450.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/search.html#keyword=DeepSeek" },
      { "name": "官方下载", "url": "https://www.deepseek.com/" }
    ]
  },
  {
    "id": 35,
    "name": "腾讯会议",
    "category": "办公通讯",
    "icon": "🟦",
    "description": "腾讯官方推出的专业高清视频会议工具，支持千人在线协同。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/1230485.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/14/detail_25154.html" },
      { "name": "官方下载", "url": "https://meeting.tencent.com/download/" }
    ]
  },
  {
    "id": 36,
    "name": "腾讯电脑管家",
    "category": "安全防护",
    "icon": "🛡️",
    "description": "腾讯推出的电脑安全管理软件，集病毒查杀、漏洞修复、清理加速于一体。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/100063.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_11112.html" },
      { "name": "官方下载", "url": "https://guanjia.qq.com/" }
    ]
  },
  {
    "id": 37,
    "name": "360安全卫士",
    "category": "安全防护",
    "icon": "🟢",
    "description": "经典的系统安全防护软件，提供体检、木马查杀及驱动安装等功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/50671.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_312.html" },
      { "name": "官方下载", "url": "https://weishi.360.cn/" }
    ]
  },
  {
    "id": 38,
    "name": "Everything",
    "category": "系统工具",
    "icon": "🔍",
    "description": "极速文件索引工具，在瞬间定位电脑中的任何文件和文件夹。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/115160.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_2733.html" },
      { "name": "官方下载", "url": "https://www.voidtools.com/zh-cn/downloads/" }
    ]
  },
  {
    "id": 39,
    "name": "Microsoft Edge",
    "category": "浏览器",
    "icon": "🌀",
    "description": "微软推出的基于 Chromium 的现代浏览器，深度整合 Bing AI 功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/1225573.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_25292.html" },
      { "name": "官方下载", "url": "https://www.microsoft.com/zh-cn/edge/download" }
    ]
  },
  {
    "id": 40,
    "name": "迅雷",
    "category": "下载工具",
    "icon": "⚡",
    "description": "专业的下载管理器，支持磁力链接、BT 种子及多线程云加速下载。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/21754.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_392.html" },
      { "name": "官方下载", "url": "https://www.xunlei.com/" }
    ]
  },
  {
    "id": 41,
    "name": "Snipaste",
    "category": "系统工具",
    "icon": "✂️",
    "description": "极其高效的截图贴图工具，支持精准识别界面元素及图像标注。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10002166.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_22673.html" },
      { "name": "官方下载", "url": "https://zh.snipaste.com/download.html" }
    ]
  },
  {
    "id": 42,
    "name": "腾讯视频",
    "category": "影音娱乐",
    "icon": "▶️",
    "description": "在线高清视频播放平台，涵盖独家综艺、影视剧及动漫资源。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/51954.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/14/detail_314.html" },
      { "name": "官方下载", "url": "https://v.qq.com/download.html" }
    ]
  },
  {
    "id": 43,
    "name": "爱奇艺",
    "category": "影音娱乐",
    "icon": "🥝",
    "description": "全球领先的视频服务平台，提供海量超清影视内容与流畅体验。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/577051.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/1/detail_1321.html" },
      { "name": "官方下载", "url": "https://www.iqiyi.com/xiazai/" }
    ]
  },
  {
    "id": 44,
    "name": "抖音 PC 版",
    "category": "影音娱乐",
    "icon": "🎵",
    "description": "抖音官方电脑客户端，大屏沉浸刷视频，支持键鼠操控与直播互动。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10079444.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/11/detail_27151.html" },
      { "name": "官方下载", "url": "https://www.douyin.com/download" }
    ]
  },
  {
    "id": 45,
    "name": "VLC Media Player",
    "category": "影音娱乐",
    "icon": "🟠",
    "description": "著名的开源多媒体播放器，支持流媒体协议及几乎所有媒体格式。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/16034.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/12/detail_1292.html" },
      { "name": "官方下载", "url": "https://www.videolan.org/vlc/" }
    ]
  },
  {
    "id": 46,
    "name": "剪映 (PC版)",
    "category": "图形视频",
    "icon": "✂️",
    "description": "全能易用的视频剪辑软件，内置丰富素材、滤镜及 AI 智能剪辑功能。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10006764.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/11/detail_26151.html" },
      { "name": "官方下载", "url": "https://www.capcut.cn/" }
    ]
  },
  {
    "id": 47,
    "name": "哔哩哔哩 (B站)",
    "category": "影音娱乐",
    "icon": "📺",
    "description": "Bilibili 官方 PC 客户端，支持 4K 播放、弹幕互动及动态查看。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10098520.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/2/detail_26942.html" },
      { "name": "官方下载", "url": "https://app.bilibili.com/" }
    ]
  },
  {
    "id": 48,
    "name": "Navicat",
    "category": "开发工具",
    "icon": "🏗️",
    "description": "顶级的数据库管理工具，支持 MySQL、PostgreSQL、Redis 等多种数据库。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/112675.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/15/detail_23235.html" },
      { "name": "官方下载", "url": "https://www.navicat.com.cn/download/navicat-premium" }
    ]
  },
  {
    "id": 49,
    "name": "百度翻译",
    "category": "系统工具",
    "icon": "🌐",
    "description": "百度官方翻译工具，支持截图翻译、划词翻译及多种语言实时互译。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10006700.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/6/detail_26746.html" },
      { "name": "官方下载", "url": "https://fanyi.baidu.com/download" }
    ]
  },
  {
    "id": 50,
    "name": "有道词典",
    "category": "系统工具",
    "icon": "📕",
    "description": "网易有道出品的多语种翻译软件，提供权威释义及离线词库。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/63310.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_313.html" },
      { "name": "官方下载", "url": "http://cidian.youdao.com/" }
    ]
  },
  {
    "id": 51,
    "name": "Steam",
    "category": "游戏娱乐",
    "icon": "🎮",
    "description": "全球最大的数字游戏发行平台，包含数万款游戏及强大的玩家社区。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/3571.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_1633.html" },
      { "name": "官方下载", "url": "https://store.steampowered.com/about/" }
    ]
  },
  {
    "id": 52,
    "name": "WeGame",
    "category": "游戏娱乐",
    "icon": "🧡",
    "description": "腾讯游戏平台，提供游戏购买、下载及完善的游戏辅助工具。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/632832.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/17/detail_22557.html" },
      { "name": "官方下载", "url": "https://www.wegame.com.cn/download" }
    ]
  },
  {
    "id": 53,
    "name": "文心一言",
    "category": "人工智能",
    "icon": "🌿",
    "description": "百度出品的生成式 AI 产品，支持智能对话、文本创作及图表生成。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10099451.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/search.html#keyword=%E6%96%87%E5%BF%83%E4%B8%80%E8%A8%80" },
      { "name": "官方下载", "url": "https://yiyan.baidu.com/" }
    ]
  },
  {
    "id": 54,
    "name": "通义千问",
    "category": "人工智能",
    "icon": "☁️",
    "description": "阿里巴巴自研的超大规模语言模型，支持复杂任务处理与创意写作。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/10099452.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/search.html#keyword=%E9%80%9A%E4%B9%89%E5%8D%83%E9%97%AE" },
      { "name": "官方下载", "url": "https://tongyi.aliyun.com/" }
    ]
  },
  {
    "id": 55,
    "name": "UU 加速器",
    "category": "游戏娱乐",
    "icon": "⚡",
    "description": "网易推出的网络加速软件，专业解决游戏联机中延迟高、掉线等问题。",
    "screenshots": [],
    "downloadLinks": [
      { "name": "华军软件园", "url": "https://www.onlinedown.net/soft/121764.htm" },
      { "name": "腾讯软件中心", "url": "https://pc.qq.com/detail/13/detail_16393.html" },
      { "name": "官方下载", "url": "https://uu.163.com/" }
    ]
  }
];

// 获取所有分类
const getCategories = () => {
  const categories = [...new Set(softwareData.map(item => item.category))];
  return categories;
};

// 按分类获取软件
const getSoftwareByCategory = (category) => {
  return softwareData.filter(item => item.category === category);
};

// 按ID获取软件
const getSoftwareById = (id) => {
  return softwareData.find(item => item.id === parseInt(id));
};

export { softwareData, getCategories, getSoftwareByCategory, getSoftwareById };